<template>
  <div class="p-home_banner2 m-is-transparent">
    <kf-video
      class="__video"
      :src="contentInfo.video"
      :autoplay="true"
      :muted="true"
      :controls="false"
      :preload="true"
      :fluid="true"
      :loop="true"
      v-if="contentInfo.video"
    />
    <div
      v-else
      class="__make"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    ></div>
    <div class="g-box">
      <div class="inner">
        <div class="inner-le">
          <div class="en">{{ dataInfo.tips }}</div>
          <div class="zh">{{ dataInfo.name }}</div>
          <div class="tit">{{ contentInfo.title }}</div>
          <div class="tips">
            {{ contentInfo.tips }}
          </div>
        </div>
        <div class="inner-ri">
          <img class="img" :src="contentInfo.image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import kfVideo from "../../../components/kf-video.vue";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      contentInfo: {},
      banner: {}
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: { kfVideo },
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    console.log(dataInfo, 12122);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 1,
      menuId: this.menuId
    });
    this.contentInfo = data[0];
    console.log(this.contentInfo, "contetinfo");
    this.dataInfo = dataInfo;
  },
  methods: {}
};
</script>
<style lang="less">
.p-home_banner2 {
  height: calc(100vh + 88px);
  overflow: hidden;
  position: relative;
  min-height: 460px;
  z-index: 1;
  box-sizing: border-box;
  .__video {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -50%;
    margin-top: -540px;
    width: 100vw;
    min-width: 1920px;
    height: 1080px;
    z-index: -2;
  }
  .video-js {
    width: 100%;
    height: 100%;
  }
  .__make {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: -1;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    // position: absolute;
    // left: 0;
    // top: 0;
    // width: 100%;
    // height: 100%;
    // background-color: rgba(0, 14, 49, 0.4);
    // z-index: -1;
  }
  .inner {
    padding-top: 163px;
    display: flex;
    &-le {
      margin-right: 20px;
      .en {
        width: 450px;
        font-size: 72px;
        font-family: "en-tit";
        color: #fff;
        line-height: 87px;
      }
      .zh {
        font-size: 48px;
        font-family: Dream-LiHeiGB, Dream;
        color: #fff;
        line-height: 54px;
      }
      .tit {
        padding-top: 185px;
        font-size: 32px;
        font-weight: 600;
        color: #fff;
        line-height: 45px;
      }
      .tips {
        padding-top: 26px;
        font-size: 18px;
        font-weight: 500;
        width: 370px;
        color: #fff;
        line-height: 36px;
      }
    }
    &-ri {
      padding-left: 37px;
      padding-right: 40px;
      padding-top: 40px;
      width: 710px;
      height: 568px;
      border-radius: 24px;
      border: 1px solid #fff;
      box-sizing: border-box;
      .img {
        display: block;
        width: 634px;
        height: 490px;
      }
    }
  }
}
</style>
